import * as React from "react";
import { cn } from "@/lib/utils";
import { CircleAlert } from "lucide-react";

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input"> & { error?: string; placeholder?: string }
>(({ className, type, error, ...props }, ref) => {
  return (
    <>
      <input
        type={type}
        className={cn(
          "flex h-[45px] focus-visible:outline-none w-full rounded-md border  bg-background px-3 text-[14px] leading-[20px] file:border-0 file:bg-transparent file:text-sm file:text-foreground placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
          !error &&
            "border-input focus-visible:border-[#A1A1AA] focus-visible:ring-offset-[#A1A1A166] focus-visible:ring-[#A1A1A166]	focus-visible:ring-[3px]",
          error &&
            "border-destructive focus-visible:ring-offset-[#DC262633] focus-visible:ring-[#DC262633]	focus-visible:ring-[3px]",
          className
        )}
        ref={ref}
        {...props}
      />
      {error && (
        <div className="w-full flex items-start justify-start text-left mt-2 ">
          <CircleAlert color="#B91C1C" height={14} width={14} />
          <p className="text-[12px] leading-[16px] text-left text-destructive ml-[6px]">
            {error}
          </p>
        </div>
      )}
    </>
  );
});
Input.displayName = "Input";

export { Input };
